export const state = {
  isLoading: false,
  totalRequest: 0,
  notification: {
    title: '',
    message: '',
    type: 'sucess',
    showed: true,
  },
};
